import {Modal} from '#/atoms/modal';
import {ReactComponent as IconDiscord} from '#/components/icons/ico-discord.svg';
import {ModalContext} from '#/contexts/modal-provider';
import {useUserProfilePrivate} from '#/hooks/query/use-user-profile';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

type CountryNotSupportedModalProps = {};
export const CountryNotSupportedModal: FunctionComponent<CountryNotSupportedModalProps> = () => {
  const {t} = useTranslation('translation');
  const {close} = useContext(ModalContext);

  const {data: userProfilePrivate} = useUserProfilePrivate({enabled: false});
  const countryCode = userProfilePrivate?.countryCode ? userProfilePrivate.countryCode : 'US';

  return (
    <Modal title={t('pages.countryNotSupported.title')} theme='dark' onClose={close}>
      <div className='p-6 pt-4 flex flex-col self-center items-center gap-4 w-[340px] relative text-white overflow-y-scroll'>
        <div className='flex items-center gap-4 py-4'>
          <ExclamationTriangleIcon className={'block w-16 h-16 fill-transparent stroke-yellowNotice'} />

          <img
            className='w-16'
            src={`https://flagsapi.com/${countryCode}/shiny/64.png`}
            alt={`Flag of ${countryCode}`}
          />
        </div>

        <div className='text-center text-sm'>
          {t('pages.countryNotSupported.unavailableExplanation', {
            countryCode: countryCode,
          })}
        </div>

        <div className='text-center text-sm'>{t('pages.countryNotSupported.requestSaved')}</div>

        <div className={'h-px w-full bg-white/70 opacity-20'} />

        <div className='text-center text-sm'>{t('pages.countryNotSupported.callToActionMessage')}</div>

        <a
          className='w-full py-2 px-4 text-white bg-deepblue font-semibold text-center rounded-md focus:outline-none hover:opacity-70'
          href='https://testnet.share.land'
          target='_blank'
          rel='noreferrer'
        >
          {t('pages.countryNotSupported.continueToTestnetButton')}
        </a>

        <a
          className='w-full py-2 px-4 text-white bg-deepblue font-semibold rounded-md focus:outline-none flex justify-center items-center gap-1 hover:opacity-70'
          href='https://discord.gg/5njaDH5y39'
          target='_blank'
          rel='noreferrer'
        >
          {t('pages.countryNotSupported.discordButton')}
          <IconDiscord className='w-5 h-5 fill-white stroke-white' />
        </a>
      </div>
    </Modal>
  );
};
